module.exports = __webpack_public_path__ + "static/seaborn-de62a419228cfc2e121e403d0f7d6a35.svg";